import styled from "styled-components";
import { palette } from "styled-theme";

const CrmWrapper = styled.div`
  height: calc(100vh - 165px);
  z-index: 10;

  .ant-layout-footer {
    background: #ffffff;
    box-shadow: 0 2px 10px rgb(0 0 0 / 16%) !important;
    z-index: 6;
    padding: 20px;
  }
  .fixed-position {
    overflow: auto;
    height: ${(props) =>
      props["hasTabs"] ? `calc(100vh - 212px)` : `calc(100vh - 165px)`};

    position: relative;
    left: ${(props) => (props["direction"] === "rtl" ? "initial" : 0)};
    right: ${(props) => (props["direction"] === "rtl" ? 0 : "initial")};
    top: 0;
    bottom: 0;
    .ant-layout-sider-children {
      overflow: auto;
    }
  }
  .activity_form {
    .activity-collpase-form {
      padding: 12px;
      .ant-collapse-header,
      .ant-collapse-content-box {
        padding: 0;
      }
    }
  }
`;

export default CrmWrapper;
